import products from "@/assets/json-data/product-data";

export default {
  state: {
    products: [],
    productCards: [],
    showProductCard: false,
    previousProductId: null,
    productIcons: [],
    productIconsToReveal: [],
    currentProductId: null,
    raiseIcon: false,
    productMotion: false,
    openProducts: false
  },
  mutations: {
    setProducts(state) {
      state.products = products;
    },
    setProductCards(state, payload) {
      state.productCards = payload;
    },
    updateShowProductCard(state, payload) {
      state.showProductCard = payload;
    },
    updatePreviousProductId(state, payload) {
      state.previousProductId = payload;
    },
    setProductIcons(state, payload) {
      state.productIcons = payload;
    },
    setProductIconsToReveal(state, payload) {
      state.productIconsToReveal = payload;
    },
    updateIsActive(state, payload) {
      state.products = payload;
    },
    updateCurrentProductId(state, payload) {
      state.currentProductId = payload;
    },
    updateRaiseIcon(state, payload) {
      state.raiseIcon = payload;
    },
    updateProductMotion(state, payload) {
      state.productMotion = payload;
    },
    updateOpenProducts(state, payload) {
      state.openProducts = payload;
    }
  },
  actions: {
    findProductCard({ state, commit }, id) {
      let productFound = state.products.find(element => {
        return element.id === id;
      });
      let tempObject = {
        ...productFound.productCard,
        name: productFound.name,
        parentId: productFound.id,
        icon: productFound.icon
      };
      let tempArray;
      if (state.productCards.length) {
        tempArray = [...state.productCards, tempObject];
      } else {
        tempArray = [tempObject];
      }
      commit("setProductCards", tempArray);
    },
    removeFirstProductCard({ state, commit }) {
      let tempArray;
      if (state.productCards.length === 1) {
        tempArray = [];
      } else {
        tempArray = [state.productCards.pop()];
      }
      commit("setProductCards", tempArray);
    },
    createProductIcons({ state, commit }) {
      let productIconArray = [];
      for (let product of state.products) {
        let tempArray = product.productIconPositions.map((icon, i) => {
          return {
            ...icon,
            parentId: product.id,
            icon: product.icon,
            delay: 0.09 * i
          };
        });
        productIconArray = [...productIconArray, ...tempArray];
      }
      commit("setProductIcons", productIconArray);
    },
    createProductsDelays({ state, commit }) {
      let tempArray = state.products.map((product, i) => {
        return {
          ...product,
          idleDelay:
            i === 0
              ? (state.products.length - 1) * 0.5
              : ((state.products.length - 1) * 0.5 - 0.5) / i
        };
      });
      commit("setProducts", tempArray);
    },
    findProductIconsToReveal({ state, commit }, id) {
      let tempArrayCombine;
      if (state.productIconsToReveal.length) {
        tempArrayCombine = [...state.productIconsToReveal, id];
      } else {
        tempArrayCombine = [id];
      }
      commit("setProductIconsToReveal", tempArrayCombine);
      let tempArrayReplace = [...state.products];
      let tempObjFound = tempArrayReplace.find(obj => obj.id == id);
      if (tempObjFound) {
        tempObjFound.isActive = true;
        tempArrayReplace.map(obj => {
          if (obj.id === tempObjFound.id) {
            return tempObjFound;
          } else {
            return obj;
          }
        });
        commit("updateIsActive", tempArrayReplace);
      }
    },
    removeProductIconsToReveal({ state, commit }, id) {
      let tempArray = state.productIconsToReveal.filter(
        arrayId => arrayId !== id
      );
      commit("setProductIconsToReveal", tempArray);

      let tempArrayReplace = [...state.products];
      let tempObjFound = tempArrayReplace.find(obj => obj.id == id);
      tempObjFound.isActive = false;
      tempArrayReplace.map(obj => {
        if (obj.id === tempObjFound.id) {
          return tempObjFound;
        } else {
          return obj;
        }
      });
      commit("updateIsActive", tempArrayReplace);
    },
    removeProductIconsActive({ state, commit }) {
      let tempArray = state.products;
      tempArray.forEach(product => {
        product.isActive = false;
      });
      commit("updateIsActive", tempArray);
    }
  }
};
